import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskAtlassianAnalyticsRoute: InvariantJiraRoute = {
	name: 'servicedesk-atlassian-analytics',
	path: '/jira/servicedesk/projects/:projectKey/reports/atlassian-analytics',
	exact: true,
};
